import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { faqs } from '../data/salesCopy';
export function FAQ() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-47" data-mp="1hdkuijvjybyr">
      <div className="mx-auto max-w-3xl" data-id="element-48" data-mp="1he2yy3sdbwhr">
        <SectionTitle data-id="element-49" data-mp="1cei2q14l228q">Questions fréquentes</SectionTitle>

        <div className="mt-5 space-y-1.5" data-id="element-50" data-mp="1cg1jdsu5ifb1">
          {faqs.map(faq => <details key={faq.q} className="group rounded-lg border border-brand-sand bg-white px-3 py-2.5" data-id="element-51" data-mp="2a1788kyhuwzc">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-2 text-[13px] font-bold leading-snug text-brand-brown sm:text-[14px]" data-id="element-52" data-mp="251b5sq5g3dlw">
                {faq.q}
                <ChevronDownIcon className="h-4 w-4 shrink-0 text-brand-taupe transition-transform duration-150 ease-smooth group-open:rotate-180" aria-hidden="true" data-id="element-53" data-mp="1v72hkeng66tj" />
              </summary>
              <p className="mt-1.5 text-[12.5px] font-medium leading-snug text-brand-brown/80 sm:text-[13.5px]" data-id="element-54" data-mp="1kngqdnsgaytk">
                {faq.a}
              </p>
            </details>)}
        </div>
      </div>
    </section>;
}